import { useState, useEffect } from "react";
import axios from "axios";
import classes from "./PDFview.module.css";
import deleteIcon from "../assets/delete_icon_red.png";

export const HEIGHT = {
  FULL: "full-height",
};

const PDFViewer = ({
  fileId,
  filePath,
  height,
  mode,
  setDeleteModal,
  fromFile = false,
}) => {
  const [pdfUrl, setPDFurl] = useState("");

  useEffect(() => {
    getPdfUrl();
  }, []);

  const getPdfUrl = async (open) => {
    try {
      // Check if filePath is already a full S3 URL
      if (filePath?.startsWith("http")) {
        setPDFurl(filePath);
        if (open) {
          window.open(filePath);
        }
        return;
      }

      // Otherwise, use the existing logic for local files
      const pdfId = filePath.split("/").pop();

      let response;

      // we used fromFile to differentiate from the old files that were saved  
      // in the backend in image folder from the ones stored in file folder(the new/correct one)
      if (fromFile) {
        response = await axios.get(
          `${process.env.REACT_APP_URL}/file/${pdfId}`,
          {
            responseType: "blob",
          }
        );
      } else {
        response = await axios.get(
          `${process.env.REACT_APP_URL}/image/${pdfId}`,
          {
            responseType: "blob",
          }
        );
      }

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const frontpdfUrl = URL.createObjectURL(pdfBlob);
      setPDFurl(frontpdfUrl);
      if (open) {
        window.open(frontpdfUrl);
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const handleDeleteModal = () => {
    setDeleteModal({
      visible: true,
      documentId: fileId,
    });
  };

  return (
    <div
      className={`${classes.mainDiv} ${
        mode !== "show" ? classes.editMainDiv : ""
      }`}
    >
      <div
        onClick={() => getPdfUrl(true)}
        className={height !== HEIGHT.FULL ? classes.overlay : null}
      ></div>
      <>
        <iframe
          src={pdfUrl}
          title={document.filename}
          className={`${classes.iframe} ${
            height === HEIGHT.FULL ? classes.fullHeightIframe : null
          }`}
        />
        {mode !== "show" ? (
          <img
            src={deleteIcon}
            alt="Delete"
            className={classes.deleteIcon}
            onClick={handleDeleteModal}
          />
        ) : null}
      </>
    </div>
  );
};

export default PDFViewer;
